// Chakra imports
import {
  Avatar,
  Badge,
  Box,
  Checkbox,
  Flex,
  Grid,
  Icon,
  Progress,
  SimpleGrid,
  Stack,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import { Card } from "@mantine/core";
import handBg from "assets/img/hand-background.png";
import Ricky from "assets/img/avatars/Ricky.png";
import Lex from "assets/img/avatars/Lex.png";
import Michael from "assets/img/avatars/Michael.png";
import Emily from "assets/img/avatars/Emily.png";
// Custom components
import LineChart from "components/Charts/LineChart";
import IconBox from "components/Icons/IconBox";
import Card2 from "components/Card/Card";
// Icons
import {
  SmallAddIcon,
  CheckCircleIcon,
  BellIcon,
  CalendarIcon,
  EditIcon,
} from "@chakra-ui/icons";
// Custom icons
import { JiraLogo, SlackLogo, TidalIconLight } from "components/Icons/Icons.js";
import React from "react";

import { IoBulb } from "react-icons/io5";
import {
  lineChartDataDefault,
  lineChartOptionsDefault,
} from "variables/charts";

export default function Default() {
  // Chakra Color Mode
  const iconBlue = useColorModeValue("blue.500", "blue.500");
  const iconBoxInside = useColorModeValue("white", "white");
  const textColor = useColorModeValue("black", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const cardColor = useColorModeValue("white", "#4A5058");
  const bgBox = useColorModeValue("gray.800", "blue.500");

  const { colorMode } = useColorMode();

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing="24px" mb="20px">
        <Card bg={cardColor}>
          <Flex direction="column">
            <Flex
              flexDirection="row"
              align="center"
              justify="center"
              w="100%"
              mb="25px"
            >
              <Stat me="auto">
                <StatLabel
                  fontSize="xs"
                  color={textColor}
                  fontWeight="bold"
                  textTransform="uppercase"
                >
                  New Case's
                </StatLabel>
                <Flex>
                  <StatNumber fontSize="lg" color={textColor} fontWeight="bold">
                    13
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox borderRadius="50%" h={"45px"} w={"45px"} bg={iconBlue}>
                <SmallAddIcon h={"24px"} w={"24px"} color={iconBoxInside} />
              </IconBox>
            </Flex>
            <Text color="gray.400" fontSize="sm">
              <Text as="span" color="green.400" fontWeight="bold">
                +3.48%{" "}
              </Text>
              Since last month
            </Text>
          </Flex>
        </Card>
        <Card bg={cardColor}>
          <Flex direction="column">
            <Flex
              flexDirection="row"
              align="center"
              justify="center"
              w="100%"
              mb="25px"
            >
              <Stat me="auto">
                <StatLabel
                  fontSize="xs"
                  color={textColor}
                  fontWeight="bold"
                  textTransform="uppercase"
                >
                  Case's Closed
                </StatLabel>
                <Flex>
                  <StatNumber fontSize="lg" color={textColor} fontWeight="bold">
                    24
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox borderRadius="50%" h={"45px"} w={"45px"} bg={iconBlue}>
                <CheckCircleIcon h={"15px"} w={"15px"} color={iconBoxInside} />
              </IconBox>
            </Flex>
            <Text color="gray.400" fontSize="sm">
              <Text as="span" color="green.400" fontWeight="bold">
                +5.2%{" "}
              </Text>
              Since last month
            </Text>
          </Flex>
        </Card>
        <Card bg={cardColor}>
          <Flex direction="column">
            <Flex
              flexDirection="row"
              align="center"
              justify="center"
              w="100%"
              mb="25px"
            >
              <Stat me="auto">
                <StatLabel
                  fontSize="xs"
                  color={textColor}
                  fontWeight="bold"
                  textTransform="uppercase"
                >
                  Outstanding Case's
                </StatLabel>
                <Flex>
                  <StatNumber fontSize="lg" color={textColor} fontWeight="bold">
                    4
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox borderRadius="50%" h={"45px"} w={"45px"} bg={iconBlue}>
                <BellIcon h={"20px"} w={"20px"} color={iconBoxInside} />
              </IconBox>
            </Flex>
            <Text color="gray.400" fontSize="sm">
              <Text as="span" color="red.500" fontWeight="bold">
                -2.82%{" "}
              </Text>
              Since last month
            </Text>
          </Flex>
        </Card>
        <Card bg={cardColor}>
          <Flex direction="column">
            <Flex
              flexDirection="row"
              align="center"
              justify="center"
              w="100%"
              mb="25px"
            >
              <Stat me="auto">
                <StatLabel
                  fontSize="xs"
                  color={textColor}
                  fontWeight="bold"
                  textTransform="uppercase"
                >
                  Monthly Total
                </StatLabel>
                <Flex>
                  <StatNumber fontSize="lg" color={textColor} fontWeight="bold">
                    67
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox borderRadius="50%" h={"45px"} w={"45px"} bg={iconBlue}>
                <CalendarIcon h={"15px"} w={"15px"} color={iconBoxInside} />
              </IconBox>
            </Flex>
            <Text color="gray.400" fontSize="sm">
              <Text as="span" color="green.400" fontWeight="bold">
                +8.12%{" "}
              </Text>
              Since last month
            </Text>
          </Flex>
        </Card>
      </SimpleGrid>
      <Grid
        templateColumns={{ sm: "1fr", xl: "1fr 2fr" }}
        templateRows={{ xl: "auto auto" }}
        maxW={{ sm: "1fr" }}
        gap="20px"
        mb="20px"
      >
        <Card2
          p="40px"
          bgImage={handBg}
          bgSize="cover"
          bgPosition="50%"
          bgRepeat="no-repeat"
          borderRadius={"4px"}
        >
          <Flex direction="column" justifyContent="flex-end" h="100%">
            <IconBox bg="white" w="38px" h="38px" mb="16px">
              <Icon as={IoBulb} color="blue.500" w="17px" h="17px" />
            </IconBox>
            <Text fontSize="2xl" color="white" fontWeight="bold">
              Get started with DA's Support Dashboard
            </Text>
            <Text color="white" maxW={{ xl: "80%" }}>
              Start your journey with our innovative efficiency dashboard!
            </Text>
          </Flex>
        </Card2>
        <Card
          p="28px 10px 0px 0px"
          mb={{ sm: "26px", lg: "0px" }}
          bg={cardColor}
        >
          <Flex direction="column" mb="20px" ps="22px" alignSelf="flex-start">
            <Text fontSize="lg" color={textColor} fontWeight="bold" mb="6px">
              Open Case's
            </Text>
            <Text fontSize="sm" fontWeight="medium" color="gray.400">
              <Text as="span" color="green.400" fontWeight="bold">
                (+5%) more
              </Text>{" "}
              in 2023
            </Text>
          </Flex>
          <Box w="100%" h={{ sm: "300px", xl: "100%" }} ps="8px">
            <LineChart
              chartData={lineChartDataDefault}
              chartOptions={lineChartOptionsDefault}
            />
          </Box>
        </Card>
        <Card bg={cardColor}>
          <Flex direction="column">
            <Text color={textColor} fontSize="lg" fontWeight="bold" mb="28px">
              Support Team Members
            </Text>
            <Stack direction="column" spacing="20px">
              <Flex justify="space-between" align="center" py="4px">
                <Flex align="center">
                  <Avatar
                    src={Ricky}
                    borderRadius="12px"
                    w="50px"
                    h="50px"
                    me="14px"
                  />
                  <Flex direction="column">
                    <Text
                      color={textColor}
                      fontSize="sm"
                      fontWeight="bold"
                      mb="4px"
                    >
                      Ricky Michal
                    </Text>
                    <Badge
                      bg="green.100"
                      color="green.400"
                      fontSize="sm"
                      px="10px"
                      w="fit-content"
                      h="25px"
                      borderRadius="8px"
                    >
                      Offline
                    </Badge>
                  </Flex>
                </Flex>
              </Flex>
              <Flex justify="space-between" align="center" py="4px">
                <Flex align="center">
                  <Avatar
                    src={Lex}
                    borderRadius="12px"
                    w="50px"
                    h="50px"
                    me="14px"
                  />
                  <Flex direction="column">
                    <Text
                      color={textColor}
                      fontSize="sm"
                      fontWeight="bold"
                      mb="4px"
                    >
                      Lex Leach
                    </Text>
                    <Badge
                      bg={useColorModeValue("red.100", "red.50")}
                      color={useColorModeValue("red.400", "red.500")}
                      fontSize="sm"
                      px="10px"
                      w="fit-content"
                      h="25px"
                      textTransform="capitalise"
                      borderRadius="8px"
                    >
                      Dev'ing
                    </Badge>
                  </Flex>
                </Flex>
              </Flex>
              <Flex justify="space-between" align="center" py="4px">
                <Flex align="center">
                  <Avatar
                    src={Michael}
                    borderRadius="12px"
                    w="50px"
                    h="50px"
                    me="14px"
                  />
                  <Flex direction="column">
                    <Text
                      color={textColor}
                      fontSize="sm"
                      fontWeight="bold"
                      mb="4px"
                    >
                      Michael Crowley
                    </Text>
                    <Badge
                      bg={useColorModeValue("gray.100", "navy.700")}
                      color={useColorModeValue("gray.400", "white")}
                      fontSize="sm"
                      px="10px"
                      w="fit-content"
                      h="25px"
                      borderRadius="8px"
                    >
                      Offline
                    </Badge>
                  </Flex>
                </Flex>
              </Flex>
              <Flex justify="space-between" align="center" py="4px">
                <Flex align="center">
                  <Avatar
                    src={Emily}
                    borderRadius="12px"
                    w="50px"
                    h="50px"
                    me="14px"
                  />
                  <Flex direction="column">
                    <Text
                      color={textColor}
                      fontSize="sm"
                      fontWeight="bold"
                      mb="4px"
                    >
                      Emily Mazariego
                    </Text>
                    <Badge
                      bg="green.100"
                      color="green.400"
                      fontSize="sm"
                      px="10px"
                      w="fit-content"
                      h="25px"
                      borderRadius="8px"
                    >
                      Online
                    </Badge>
                  </Flex>
                </Flex>
              </Flex>
            </Stack>
          </Flex>
        </Card>
        <Grid templateColumns={{ sm: "1fr", xl: "repeat(2, 1fr)" }} gap="20px">
          <Card bg={cardColor}>
            <Flex direction="column">
              <Text color={textColor} fontSize="lg" fontWeight="bold" mb="14px">
                To Do List
              </Text>
              <Stack direction="column" spacing="14px">
                <Flex
                  justify="space-between"
                  align="center"
                  borderBottom="1px solid"
                  borderColor={borderColor}
                  py="12px"
                >
                  <Flex direction="column">
                    <Text
                      color={textColor}
                      fontWeight="bold"
                      fontSize="sm"
                      mb="3.5px"
                    >
                      Call with Andrew
                    </Text>
                    <Text color="gray.400" fontSize="sm">
                      09:30 AM
                    </Text>
                  </Flex>
                  <Checkbox colorScheme="blue" defaultChecked size="lg" />
                </Flex>
                <Flex
                  justify="space-between"
                  align="center"
                  borderBottom="1px solid"
                  borderColor={borderColor}
                  py="12px"
                >
                  <Flex direction="column">
                    <Text
                      color={textColor}
                      fontWeight="bold"
                      fontSize="sm"
                      mb="3.5px"
                    >
                      Brunch Meeting
                    </Text>
                    <Text color="gray.400" fontSize="sm">
                      11:00 AM
                    </Text>
                  </Flex>
                  <Checkbox colorScheme="blue" defaultChecked size="lg" />
                </Flex>
                <Flex
                  justify="space-between"
                  align="center"
                  borderBottom="1px solid"
                  borderColor={borderColor}
                  pt="12px"
                >
                  <Flex direction="column">
                    <Text
                      color={textColor}
                      fontWeight="bold"
                      fontSize="sm"
                      mb="3.5px"
                    >
                      DA Support Dashboard 2.0 Launch
                    </Text>
                    <Text color="gray.400" fontSize="sm">
                      02:00 PM
                    </Text>
                  </Flex>
                  <Checkbox colorScheme="blue" size="lg" />
                </Flex>
                <Flex justify="space-between" align="center" py="14px">
                  <Flex direction="column">
                    <Text
                      color={textColor}
                      fontWeight="bold"
                      fontSize="sm"
                      mb="3.5px"
                    >
                      Violin Lesson
                    </Text>
                    <Text color="gray.400" fontSize="sm">
                      04:00 PM
                    </Text>
                  </Flex>
                  <Checkbox colorScheme="blue" size="lg" />
                </Flex>
              </Stack>
            </Flex>
          </Card>
          <Card bg={cardColor}>
            <Flex direction="column" w="100%">
              <Text color={textColor} fontSize="lg" fontWeight="bold" mb="14px">
                Progress Track
              </Text>
              <Stack direction="column" spacing="14px" w="100%">
                <Flex
                  align="center"
                  borderBottom="1px solid"
                  borderColor={borderColor}
                  py="16px"
                >
                  <JiraLogo w="40px" h="40px" me="18px" />
                  <Flex direction="column" w="100%">
                    <Text
                      fontSize="sm"
                      color={textColor}
                      fontWeight="bold"
                      mb="10px"
                    >
                      Monthly Recurring Tasks
                    </Text>
                    <Progress colorScheme="blue" size="xs" value={70} />
                  </Flex>
                </Flex>
                <Flex
                  align="center"
                  borderBottom="1px solid"
                  borderColor={borderColor}
                  py="16px"
                >
                  <EditIcon w="40px" h="40px" me="18px" />
                  <Flex direction="column" w="100%">
                    <Text
                      fontSize="sm"
                      color={textColor}
                      fontWeight="bold"
                      mb="10px"
                    >
                      Open Case's
                    </Text>
                    <Progress colorScheme="pink" size="xs" value={40} />
                  </Flex>
                </Flex>
                <Flex
                  align="center"
                  borderBottom="1px solid"
                  borderColor={borderColor}
                  py="16px"
                >
                  <TidalIconLight w="40px" h="40px" me="18px" />
                  <Flex direction="column" w="100%">
                    <Text
                      fontSize="sm"
                      color={textColor}
                      fontWeight="bold"
                      mb="10px"
                    >
                      Tidal Integration
                    </Text>
                    <Progress colorScheme="green" size="xs" value={70} />
                  </Flex>
                </Flex>
                <Flex align="center" pt="14px">
                  <SlackLogo w="40px" h="40px" me="18px" />
                  <Flex direction="column" w="100%">
                    <Text
                      fontSize="sm"
                      color={textColor}
                      fontWeight="bold"
                      mb="10px"
                    >
                      Slack Integration
                    </Text>
                    <Progress colorScheme="purple" size="xs" value={70} />
                  </Flex>
                </Flex>
              </Stack>
            </Flex>
          </Card>
        </Grid>
      </Grid>
    </Flex>
  );
}
